import InputSelect from '../../components/InputSelect';
import InputText from '../../components/InputText';
import InputTextArea from '../../components/InputTextArea';
import InputDate from '../../components/InputDate';

export default function Form2({ data, setData, species, sterilisationStatus, animalSex,validationLabel,setValidationLabel }) {


    //Mise à jour des data lors de la modification d'un champ
    const handleChange = (e) => {
        const { name, value } = e.target;
        if(name==="anamnesis"){
            setData((prevData) => ({
                ...prevData,
                anamnesis: value
            }))
        } else {
            setData((prevData) => ({
                ...prevData,
                pet: prevData.pet.handleChange(name, value)
            }))
        }
        setValidationLabel((prevData) => ({
            ...prevData,
            [name]: ""
        }))
    }



    return (
        <div className="p-3 basis-1/3">
            <h1 className="text-lg mb-3">Animal</h1>
            <form className="flex flex-col gap-2">
                <InputText validationLabel={validationLabel.petName} name="petName" value={data.pet.name} onChange={handleChange} placeholder="Nom de l'animal*" />
                <InputText validationLabel={validationLabel.chip} name="chip" value={data.pet.chip} onChange={handleChange} placeholder="ID Chip" />
                <InputSelect validationLabel={validationLabel.specie} options={species} placeholder="Espèce*" defaultValue={data.pet.specie_id || ""} onChange={handleChange} name="specie" />
                <InputText validationLabel={validationLabel.breed} name="breed" value={data.pet.getBreedNameSync()} onChange={handleChange} placeholder="Race" />
                <InputDate validationLabel={validationLabel.birthDate} name="date" value={data.pet.birth_date} onChange={handleChange} placeholder="Date de naissance" />
                <div className="flex flex-row gap-2">
                    <InputSelect validationLabel={validationLabel.sex} options={animalSex} placeholder="Sexe" onChange={handleChange} defaultValue={data.pet.sex_id || ""} name="sex" />
                    <InputSelect validationLabel={validationLabel.sterilisation} options={sterilisationStatus} placeholder="Stérilisation" onChange={handleChange} defaultValue={data.pet.sterilisation_id || ""} name="sterilisation" />
                </div>
                <InputTextArea rows="7" validationLabel={validationLabel.anamnesis} name="anamnesis" value={data.anamnesis} onChange={handleChange} placeholder="Anamnèse"/>
                <p className="text-sm text-gray">*Champs obligatoires</p>
            </form>
        </div>
    );
}
